import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  settings: {
    id: 't.settings',
    defaultMessage: 'Settings',
  },
  myProfile: {
    id: 't.myProfile',
    defaultMessage: 'My Profile',
  },
  help: {
    id: 't.help',
    defaultMessage: 'Help',
  },
  community: {
    id: 't.community',
    defaultMessage: 'Community',
  },
  openInDesktopApp: {
    id: 't.openInDesktopApp',
    defaultMessage: 'Open In App',
  },
  signOut: {
    id: 't.signOut',
    defaultMessage: 'Sign Out',
  },
  nowPlaying: {
    id: 't.nowPlaying',
    defaultMessage: 'Now Playing',
  },
  myCollection: {
    id: 't.myCollection',
    defaultMessage: 'My Collection',
  },
  browse: {
    id: 't.browse',
    defaultMessage: 'Browse',
  },
} as const);
